import type { ResultOf } from '@graphql-typed-document-node/core'
import { graphql } from '~/lib/graphql'

export const RestaurantMenusFragment = graphql(/* GraphQL */ `
  fragment RestaurantMenusFragment on Restaurant {
    menus {
      course {
        ...RestaurantMenuRootFragment
      }
      aLaCarte {
        ...RestaurantMenuRootFragment
      }
      drink {
        ...RestaurantMenuRootFragment
      }
    }
  }
`)

export type Menus = ResultOf<typeof RestaurantMenusFragment>['menus']

export const RestaurantMenuRootFragment = graphql(/* GraphQL */ `
  fragment RestaurantMenuRootFragment on RestaurantMenuRoot {
    sections {
      title
      description
      items {
        name
        description
        price
        isRecommended
      }
    }
    updatedDate
  }
`)
